import React, { forwardRef } from 'react';

import SVGText from './SVGText';

const SmallSVGText = forwardRef<SVGTextElement, React.ComponentPropsWithoutRef<'text'>>(
  (props, ref) => <SVGText {...props} ref={ref} fontSize="12" />
);

export default SmallSVGText;
